import { actionSuffix } from './utils';

const QUERY = 'QUERY';
const CONFIGURATION = 'CONFIGURATION';
export const actionTypes = {
    LOG_OUT: 'LOG_OUT',
    LOG_IN_SUCCESS: actionSuffix.success('LOG_IN'),
    CONFIGURATION_START: actionSuffix.start(CONFIGURATION),
    CONFIGURATION_SUCCESS: actionSuffix.success(CONFIGURATION),
    CONFIGURATION_FAILURE: actionSuffix.fail(CONFIGURATION),
    SAVE_INPUT_VALUE: 'SAVE_INPUT_VALUE',
    QUERY_START: actionSuffix.start(QUERY),
    QUERY_SUCCESS: actionSuffix.success(QUERY),
    QUERY_FAILURE: actionSuffix.fail(QUERY)
};

export function logInSucceeded(userProfile) {
    return { type: actionTypes.LOG_IN_SUCCEED, userProfile };
}
export function logOut() {
    return { type: actionTypes.LOG_OUT };
}
export function saveInputValueToRedux(key, value) {
    return { type: actionTypes.SAVE_INPUT_VALUE, data: { key, value } };
}
